import { API } from "aws-amplify"

export const getInstallations = (transformerId) => {
    return API.get('baseURL', `/ae/installations?transformerId=${transformerId}`)
}
